module.exports = __webpack_public_path__ + "static/img/rwtz.6c81ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xin/rwtz.jpg
// module id = 185
// module chunks = 1